import React from 'react';
import SourceBadge from './SourceBadge';

const ValuationCard = ({ listing, propertyData, isProUser, onSubscriptionModal }) => {
  if (!isProUser) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
        <div className="p-5">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
              <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-gray-900">Valuation Details</h4>
          </div>
          
          <div className="space-y-3">
            {/* All Premium Content Locked */}
            <div className="relative">
              <div className="blur-sm pointer-events-none">
                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-sm font-medium text-gray-600">Upset Value</span>
                  <span className="text-sm font-semibold text-gray-900">$XXX,XXX</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-sm font-medium text-gray-600">Zillow Estimate</span>
                  <span className="text-sm font-semibold text-gray-900">$XXX,XXX</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-sm font-medium text-gray-600">Potential Profit</span>
                  <span className="text-sm font-bold text-green-600">$XX,XXX</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-sm font-medium text-gray-600">Rent Estimate</span>
                  <span className="text-sm font-semibold text-purple-600">$X,XXX/month</span>
                </div>
              </div>
              
              {/* Upgrade Overlay */}
              <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-90 rounded-lg">
                <div className="text-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <h5 className="text-sm font-semibold text-gray-900 mb-1">Premium Feature</h5>
                  <p className="text-xs text-gray-600 mb-3">Upgrade to view detailed valuation</p>
                  <button
                    onClick={() => onSubscriptionModal && onSubscriptionModal()}
                    className="inline-flex items-center px-3 py-1.5 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-xs font-medium rounded-md hover:from-yellow-500 hover:to-orange-600 transition-all duration-200 shadow-sm"
                  >
                    <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>
                    Upgrade to PRO
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
      <div className="p-5">
        <div className="flex items-center mb-4">
          <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
            <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
            </svg>
          </div>
          <h4 className="text-lg font-semibold text-gray-900">Valuation Details</h4>
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Upset Value</span>
            <span className="text-sm font-semibold text-gray-900">{listing.upset_value || 'N/A'}</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Zillow Estimate</span>
            <div className="flex items-center">
              <span className="text-sm font-semibold text-gray-900 mr-2">{listing.marketValueFormatted || 'N/A'}</span>
              {listing.dataSource && <SourceBadge source={listing.dataSource} />}
            </div>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">Potential Profit</span>
            <div className="text-right">
              <span className={`text-sm font-bold ${
                listing.profit > 0 ? 'text-green-600' : 'text-red-600'
              }`}>
                {listing.profitFormatted || 'N/A'}
              </span>
              {listing.profitPercentage && (
                <div className="text-xs text-gray-500">
                  ({listing.profitPercentage > 0 ? '+' : ''}{listing.profitPercentage.toFixed(1)}%)
                </div>
              )}
            </div>
          </div>
          
          {/* Rent Estimate */}
          {propertyData && propertyData.status === 'success' && propertyData.data && propertyData.data.rentZestimate && (
            <div className="flex justify-between items-center py-2 border-b border-gray-100">
              <span className="text-sm font-medium text-gray-600">Rent Estimate</span>
              <span className="text-sm font-semibold text-purple-600">
                ${propertyData.data.rentZestimate.toLocaleString()}/month
              </span>
            </div>
          )}
        </div>
        
        {/* Investment Metrics Summary */}
        {listing.profit !== undefined && propertyData && propertyData.data && propertyData.data.rentZestimate && (
          <div className="mt-4 p-3 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-green-200">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-gray-700">Investment Potential</span>
              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                listing.profit > 50000 ? 'bg-green-100 text-green-800' : 
                listing.profit > 25000 ? 'bg-yellow-100 text-yellow-800' : 
                listing.profit > 0 ? 'bg-blue-100 text-blue-800' : 
                'bg-red-100 text-red-800'
              }`}>
                {listing.profit > 50000 ? 'Excellent' : 
                 listing.profit > 25000 ? 'Good' : 
                 listing.profit > 0 ? 'Fair' : 'Poor'}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValuationCard;